import React from 'react';
import NavElem from './NavElem';
import { useTheme } from '../hooks/useTheme';
import dictionaryIconLight from '../assets/light/dictionaryIcon.svg';
import aiIconLight from '../assets/light/aiNavIcon.svg';
import homeIconLight from '../assets/light/homeIcon.svg';
import subscriptionIconLight from '../assets/light/subscriptionIcon.svg';
import accountIconLight from '../assets/light/accountIcon.svg';
import dictionaryIconDark from '../assets/dark/dictionaryIcon.svg';
import aiIconDark from '../assets/dark/aiNavIcon.svg';
import homeIconDark from '../assets/dark/homeIcon.svg';
import subscriptionIconDark from '../assets/dark/subscriptionIcon.svg';
import accountIconDark from '../assets/dark/accountIcon.svg';
function BottomNav() {
  const { theme } = useTheme();
  const navElems = [
    { 
      href: '/dictionary', 
      name: 'Dictionary', 
      title: 'Словарь', 
      image: theme === 'light' ? dictionaryIconLight : dictionaryIconDark
    },
    { 
      href: '/ai', 
      name: 'AI', 
      title: 'ИИ', 
      image: theme === 'light' ? aiIconLight : aiIconDark
    },
    { 
      href: '/', 
      name: 'Home', 
      title: 'Главная', 
      image: theme === 'light' ? homeIconLight : homeIconDark
    },
    { 
      href: '/subscription', 
      name: 'Subscription', 
      title: 'Подписка', 
      image: theme === 'light' ? subscriptionIconLight : subscriptionIconDark
    },
    { 
      href: '/account', 
      name: 'Account', 
      title: 'Аккаунт', 
      image: theme === 'light' ? accountIconLight : accountIconDark
    }
  ];
  return (
    <nav className="bottom-nav">
      {navElems.map((navElem) => (
        <NavElem key={navElem.name} routeInfo={navElem} />
      ))}
    </nav>
  );
}
export default BottomNav; 